import React, { useEffect, useState } from 'react';
import styles from './Quienes_somos.module.css';
import logo from '../../assets/defensa2.webp'; 

const AboutUsComponent = ({ onClose }) => {
  const [showCards, setShowCards] = useState([false, false]);
  
  useEffect(() => {
    // Animación secuencial para las tarjetas
    setTimeout(() => setShowCards([true, false]), 100);
    setTimeout(() => setShowCards([true, true]), 500);
  }, []);

  return (
    <div className={styles.container}>
      {/* Close Button */}
      <button onClick={onClose} className={styles.closeButton}>
        ✕ Cerrar
      </button>
      
      {/* Hero Section */}
      <div className={styles.heroSection}>
        {/* Background Pattern */}
        <div className={styles.heroOverlay}></div>
        <div className={styles.heroGradient}></div>
        
        {/* Decorative Elements */}
        <div className={styles.decorativeElement1}></div>
        <div className={styles.decorativeElement2}></div>
        <div className={styles.decorativeElement3}></div>
        
        {/* Content */}
        <div className={styles.heroContent}>
          <div className={styles.heroText}>
            {/* Logo */}
            <div className={styles.logoContainer}>
              <img src={logo} alt="DYD Asesorías" className={styles.logo} />
            </div>
            <p className={styles.heroSubtitle}>
              Especialistas en Recuperación de Activos Financieros
            </p>
            <div className={styles.heroLine}></div>
          </div>
        </div>
        
        {/* Bottom Wave */}
        <div className={styles.waveContainer}>
          <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className={styles.waveSvg}>
            <path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z"></path>
          </svg>
        </div>
      </div>

      {/* Content Section */}
      <div className={styles.contentSection}>
        <div className={styles.contentContainer}>
          {/* Título "QUIÉNES SOMOS" */}
          <h2 className={styles.sectionTitle}>QUIÉNES SOMOS</h2>
          
          {/* Texto Quiénes Somos */}
          <div className={styles.aboutText}>
            <p>
              Somos una firma de asesores jurídicos, con sede en Manizales, especializados en la recuperación de saldos a favor y activos financieros. Nuestro equipo actúa con total independencia y autonomía técnica, empleando su profundo conocimiento y experiencia para representar a titulares, beneficiarios y herederos ante entidades públicas y privadas vigiladas por la Superintendencia Financiera de Colombia.
            </p>
            <p>
              Haciendo uso de las tecnologías de la información y los mecanismos de justicia digital, gestionamos de manera eficiente todos los trámites necesarios, garantizando una cobertura completa desde nuestra sede principal para defender sus derechos en todo el territorio nacional.
            </p>
          </div>
          
          {/* Cards Container - Una encima de otra */}
          <div className={styles.cardsColumn}>
            {/* Misión Card */}
            <div className={`${styles.card} ${styles.emeraldCard} ${showCards[0] ? styles.cardVisible : ''}`}>
              <div className={styles.cardHeader}>
                <div className={`${styles.cardIcon} ${styles.emeraldIcon}`}>
                  <svg className={styles.cardIconSvg} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"></path>
                  </svg>
                </div>
                <h2 className={`${styles.cardTitle} ${styles.emeraldTitle}`}>MISIÓN</h2>
              </div>
              <p className={`${styles.cardText} ${styles.emeraldText}`}>
                Nuestra misión es gestionar con la máxima diligencia y compromiso todas las acciones jurídicas y administrativas necesarias para asegurar la reclamación y devolución efectiva de los saldos que por ley le pertenecen a nuestros clientes. A través de una asesoría experta y una representación legal íntegra, trabajamos para garantizar el acceso a sus derechos y la defensa de su patrimonio.
              </p>
            </div>

            {/* Visión Card */}
            <div className={`${styles.card} ${styles.purpleCard} ${showCards[1] ? styles.cardVisible : ''}`}>
              <div className={styles.cardHeader}>
                <div className={`${styles.cardIcon} ${styles.purpleIcon}`}>
                  <svg className={styles.cardIconSvg} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                  </svg>
                </div>
                <h2 className={`${styles.cardTitle} ${styles.purpleTitle}`}>VISIÓN</h2>
              </div>
              <p className={`${styles.cardText} ${styles.purpleText}`}>
                Ser la firma líder y de mayor confianza en Colombia en la recuperación de activos y saldos a favor, reconocidos por nuestra eficiencia, transparencia y el uso innovador de la tecnología. Aspiramos a ser el principal aliado de nuestros clientes en la defensa de sus derechos financieros.
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default AboutUsComponent;